import { message, Modal } from "ant-design-vue";
import axios from "axios";
import Vue from "vue";
import { createFormData, formatTime } from "./utils";

export function blockUser(user) {
    const store = new Vue({
        data: {
            time: 30,
            reason: "",
        }
    });
    const STYLE_ID = "__block-dialog-stylesheet__";
    if (!document.getElementById(STYLE_ID)) {
        const style = document.createElement("style");
        style.innerHTML = /* CSS */`
        .block-dialog > .time > .ant-btn {
            margin: 0 5px;
        }
        `;
        style.id = STYLE_ID;
        document.body.appendChild(style);
    }
    const modal = Modal.confirm({
        title: "封禁用户",
        content: (h) => {
            const setTime = (time) => {
                return () => store.time = time;
            };
            return (
            <div class="block-dialog">
                <div>
                    正在封禁用户<a href={`/user/?id=${ user.id }`} target="_blank">{ user.name }</a>
                </div>
                <div class="time">
                    封禁时长:<a-input v-model={store.time} suffix="分钟" /><br/>
                    预设: <br/>
                    <a-button size="small" onClick={setTime(30)}>30分钟</a-button>
                    <a-button size="small" onClick={setTime(60*24)}>1天</a-button>
                    <a-button size="small" onClick={setTime(60*24*7)}>7天</a-button>
                    <a-button size="small" onClick={setTime(60*24*30)}>30天</a-button>
                    <a-button size="small" onClick={setTime(60*24*365*100)}>100年</a-button>
                </div>
                <div>
                    封禁理由:<a-input v-model={store.reason} />
                </div>
            </div>
            );
        },
        onOk: async () => {
            const endtime = store.time * 60 + ~~(Date.now() / 1000);
            const { data } = await axios
                .post("/backend/admin/user/block.php", createFormData({
                    id: user.id, endtime, reason: store.reason
                }));
            if (data.code === 0) {
                message.success(`封禁成功, 结束时间: ${ formatTime(endtime) }`);
            } else {
                message.error(`封禁失败`);
            }
        }
    })
}

export async function prompt(title) {
    const store = new Vue({
        data: {
            text: "",
        }
    });
    const STYLE_ID = "__block-dialog-stylesheet__";
    if (!document.getElementById(STYLE_ID)) {
        const style = document.createElement("style");
        style.innerHTML = /* CSS */`
        .block-dialog > .time > .ant-btn {
            margin: 0 5px;
        }
        `;
        style.id = STYLE_ID;
        document.body.appendChild(style);
    }
    return new Promise((res) => {
        const modal = Modal.confirm({
            title,
            content: (h) => {
                return (
                    <div class="block-dialog">
                        <a-input v-model={store.text} />
                    </div>
                );
            },
            onOk: () => {
                res(store.text);
            },
            onCancel: () => {
                res(null);
            }
        })
    })
}
